import { Else, If, Then } from 'react-if';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { Language } from '@zep/types';
import Empty from '../../components/service/common/Empty';
import StoreSaveList from '../../components/service/stores/StoreList/StoreSaveList';
import { useStoreSavedItems } from '../../services';
import type { StorePageType } from '../../types';
import S from './Store.module.scss';
export const StoreSavePageView = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const {
    user
  } = useAuth();
  const saveType = router.query?.type as StorePageType ?? 'like';
  const saveData = useStoreSavedItems(saveType, user?.isEdu, router.locale as Language);
  if (!saveData.isSuccess) {
    return <></>;
  }
  return <If condition={!saveData.data?.maps.length && !saveData.data?.objects.length && !saveData.data?.apps.length && !saveData.data?.games.length} data-sentry-element="If" data-sentry-component="StoreSavePageView" data-sentry-source-file="save.tsx">
      <Then data-sentry-element="Then" data-sentry-source-file="save.tsx">
        <div className={S.empty_wrapper}>
          <Empty emptyItem={saveType === 'like' ? t('store:store_asset_liked') : t('store:store_asset_purchased')} description={t('store:store_empty_asset_description')} image={{
          url: '/images/light/assetStore/empty_box.png',
          width: 125,
          height: 125
        }} ctaText={t('store:store_empty_asset_cta')} onClickCTA={() => router.push('/store')} data-sentry-element="Empty" data-sentry-source-file="save.tsx" />
        </div>
      </Then>
      <Else data-sentry-element="Else" data-sentry-source-file="save.tsx">
        <StoreSaveList listTitle={saveType === 'like' ? t('store:store_liked_assets', {
        x: t('store:store_asset_map')
      }) : t('store:store_asset_map')} items={saveData.data?.maps ?? []} type="map" data-sentry-element="StoreSaveList" data-sentry-source-file="save.tsx" />
        <StoreSaveList listTitle={saveType === 'like' ? t('store:store_liked_assets', {
        x: t('store:store_asset_object_set')
      }) : t('store:store_asset_object_set')} items={saveData.data?.objects ?? []} type="object" data-sentry-element="StoreSaveList" data-sentry-source-file="save.tsx" />
        <StoreSaveList listTitle={saveType === 'like' ? t('store:store_liked_assets', {
        x: t('store:store_asset_app')
      }) : t('store:store_asset_app')} items={saveData.data?.apps ?? []} type="app" data-sentry-element="StoreSaveList" data-sentry-source-file="save.tsx" />
        <StoreSaveList listTitle={saveType === 'like' ? t('store:store_liked_assets', {
        x: t('store:store_asset_game')
      }) : t('store:store_asset_game')} items={saveData.data?.games ?? []} type="game" data-sentry-element="StoreSaveList" data-sentry-source-file="save.tsx" />
      </Else>
    </If>;
};